// extracted by mini-css-extract-plugin
export default {"btn":"ButtonSecondary_btn__41Avq"};